// extracted by mini-css-extract-plugin
export default {"oval":"MobilePage_oval__1lBz9","rectangle":"MobilePage_rectangle__0kFt2"};